import React, { Component } from 'react';
import RefundCancellationReceipt from '../components/Remittance/RefundCancellationReceipt';
import { getRefundRemittanceReportData } from '../services/ReportService';

export default class RefundRemittanceReceipt extends Component {

  constructor(){
    super();
    this.language = 'en';
    var count = window.location.pathname.split('/').length; 
    this.tid = window.location.pathname.split('/')[2];
    this.isReprintData = false;
    var reprint = window.location.search; 
    if (reprint == ''){
        this.isReprintData = false;
    }else{
      this.isReprintData = true;
    }
    this.state = { reportData: null };
  }
  componentDidMount() {

    getRefundRemittanceReportData(this.tid, this.language).then((res) => {
      this.setState({reportData : res.data});
    });
  }
  render() {
    return (
      this.state.reportData ?
        <div>
          <RefundCancellationReceipt result={this.state.reportData} isBankCopy={false} isReprint={this.isReprintData}/>
          <RefundCancellationReceipt result={this.state.reportData} isBankCopy={true} isReprint={this.isReprintData}/>
        </div>
        : <div></div>
    );
  }
}
